import { multiSelect } from 'react-redux-app/lib/modules/form/utils';
import convertMoneyToCurrency from '../../core/money/utils/convertMoneyToCurrency';
import formatMoney from '../../core/money/utils/formatMoney';

import { COUNTRY__US } from '../../core/country/constants';
import { CURRENCY_EUR, CURRENCY_USD } from '../../core/money/constants';


export const getBalanceTotal = ({ revenue, bonus, lossCompensationDebt }) => ({
  amount: (revenue.amount + bonus.amount) - lossCompensationDebt.amount,
  currency: revenue.currency,
});

export const convertBalanceToCurrency = (balance, convertToCurrency, exchangeRatesForEur) => {
  const { revenue, bonus, lossCompensationDebt } = balance;
  return {
    revenue: convertMoneyToCurrency(
      revenue,
      convertToCurrency,
      exchangeRatesForEur
    ),
    bonus: convertMoneyToCurrency(
      bonus,
      convertToCurrency,
      exchangeRatesForEur
    ),
    lossCompensationDebt: convertMoneyToCurrency(
      lossCompensationDebt,
      convertToCurrency,
      exchangeRatesForEur
    ),
  };
};

export const getIsUS = country => country === COUNTRY__US;
export const getCurrencyByCountry = country => (getIsUS(country) ? CURRENCY_USD : CURRENCY_EUR);

export const getMinimumPayoutOptions = country => ['100', '200', '300', '400', '500']
  .map(value => multiSelect.createOption(
    formatMoney({
      amount: parseInt(value, 10),
      currency: getCurrencyByCountry(country),
    }),
    value
  ));
